export const initWebinarRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/webinar",
          name: "webinar",
          component: () => import("@/pages/manage/webinars/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors,config.roles.eventManagers],
          },
        },
        {
          path: "/manage/webinar/:id",
          name: "webinar-id",
          component: () => import("@/pages/manage/webinars/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors,config.roles.eventManagers],
          },
        },
      ];
